import React, { useEffect, useRef, useState } from "react";
import ImageReveal from "./ImageReveal";

const About = () => {
  const [counters, setCounters] = useState({
    clients: 0,
    success: 0,
    experience: 0
  });

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
          animateCounters();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  const animateCounters = () => {
    const targets = {
      clients: 500,
      success: 95,
      experience: 10
    };

    const duration = 2000; // 2 seconds
    const steps = 60; // 60 steps for smooth animation
    const stepDuration = duration / steps;

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);

      setCounters({
        clients: Math.floor(targets.clients * easeOutQuart),
        success: Math.floor(targets.success * easeOutQuart),
        experience: Math.floor(targets.experience * easeOutQuart)
      });

      if (currentStep >= steps) {
        clearInterval(timer);
        // Ensure final values are exact
        setCounters({
          clients: targets.clients,
          success: targets.success,
          experience: targets.experience
        });
      }
    }, stepDuration);
  };

  return (
    <section id="about" className="about" ref={sectionRef}>
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About HEM SALES AGENCIES</h2>
            <p>
              We are a leading industrial solutions provider dedicated to helping
              businesses achieve their growth objectives. With years of
              experience and a proven track record, we provide comprehensive
              machinery, fire safety, and technical services that drive measurable
              results and sustainable growth.
            </p>
            <p>
              Our team of experienced professionals combines industry
              expertise with cutting-edge methodologies to deliver exceptional
              outcomes for our clients across various sectors including
              manufacturing, education, and government institutions.
            </p>
            <div className="stats">
              <div className="stat">
                <h3 className="counter">{counters.clients}+</h3>
                <p>Clients Served</p>
              </div>
              <div className="stat">
                <h3 className="counter">{counters.success}%</h3>
                <p>Success Rate</p>
              </div>
              <div className="stat">
                <h3 className="counter">{counters.experience}+</h3>
                <p>Years Experience</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <ImageReveal 
              src="/Images/about-image.jpeg" 
              alt="About HEM SALES AGENCIES"
              objectFit="cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
